import React from 'react';
import Grid from '../../common/Grid/Grid';
import SessionCardItem from './SessionCardItem';

/**
 * SessionGrid - Virtualized grid for displaying feedback session cards
 * Uses the shared Grid component with react-window for performance
 */
const SessionGrid = ({
  sessions,
  isLoading,
  isLoadingMore,
  pageInfo,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  loadMoreData,
  gridRef,
  // Action handlers
  onView,
  onEdit,
  onEditEmployees,
  onEditReviewers,
  onDelete,
  onPublishConfigure,
  onPublishStart,
  onPublishComplete,
  onCloseWithIncomplete,
  onViewReport,
  ability,
  searchInputValue,
}) => {
  const renderSessionItem = ({ item }) => {
    return (
      <SessionCardItem
        session={item}
        onView={onView}
        onEdit={onEdit}
        onEditEmployees={onEditEmployees}
        onEditReviewers={onEditReviewers}
        onDelete={onDelete}
        onPublishConfigure={onPublishConfigure}
        onPublishStart={onPublishStart}
        onPublishComplete={onPublishComplete}
        onCloseWithIncomplete={onCloseWithIncomplete}
        onViewReport={onViewReport}
        ability={ability}
      />
    );
  };

  // Dynamic empty state description based on search
  const emptyStateDescription = searchInputValue
    ? "No sessions match your search criteria. Try adjusting your filters."
    : "There are no feedback sessions scheduled yet. Click the '+ Schedule Session' button to create a new one.";

  return (
    <Grid
      items={sessions}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      pageInfo={pageInfo}
      renderItem={renderSessionItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={loadMoreData}
      gridRef={gridRef}
      emptyStateTitle="No Feedback Sessions Found"
      emptyStateDescription={emptyStateDescription}
      endOfListMessage="You've reached the end of the list"
      rowHeight={580}
    />
  );
};

export default SessionGrid;
